export default __webpack_public_path__ + "static/media/logo.b258808c.svg";